import { isLinkExternal } from "../utilities/ElementHelpers"

document.addEventListener('DOMContentLoaded', () => {

  // append target="_blank" to external links that don't already have target attribute set
  document.querySelectorAll<HTMLAnchorElement>('a:not([target])').forEach(element => {
    if (isLinkExternal(element)) {
      element.setAttribute('target', '_blank');
    }
  });

  document.querySelectorAll<HTMLElement>('.card.card--service').forEach(element => {
    element.addEventListener('click', () => {
      const anchor = element.querySelector<HTMLAnchorElement>('.card-actions a.btn');
      if (anchor)
        anchor.click();

      return false;
    });
  });

  // on hover of button, add zoom ease to background image
  document.querySelectorAll<HTMLAnchorElement>('[zoom-image-effect] a').forEach(element => {
    element.addEventListener('mouseenter', () => handleAnchorHoverForBackgroundZoom(element, true));
    element.addEventListener('mouseleave', () => handleAnchorHoverForBackgroundZoom(element, false));
  });
})

const handleAnchorHoverForBackgroundZoom = (anchorEl: HTMLAnchorElement, isEnter: boolean) => {
  const container = anchorEl.closest('[zoom-image-effect]');
  isEnter ? container.setAttribute('zoom-image-effect', 'active') : container.setAttribute('zoom-image-effect', 'inactive');
}
